import { WarningAlert } from '@/components/alerts';
import { Text } from '@mantine/core';
import { IconHomeExclamation } from '@tabler/icons-react';
import { useMemo } from 'react';
import styles from './styles.module.css';
import { useNearestLocation } from './use-nearest-location/hook';

type Props = {
	lat: number | null | undefined;
	lng: number | null | undefined;
};

export const NotEligibleAlert = ({ lat, lng }: Props) => {
	const { nearestLocation, loading } = useNearestLocation(lat, lng);

	const children = useMemo(() => {
		if (loading) {
			return (
				<Text size="14px" fw={400}>
					Finding nearest location...
				</Text>
			);
		}

		if (nearestLocation) {
			return (
				<>
					<Text size="14px" fw={400}>
						You can drop your Curby bags at your nearest drop-off point:
					</Text>
					<br />
					<Text size="14px" fw={400}>
						{[nearestLocation.retailer, nearestLocation.name].filter(Boolean).join(' - ')}
					</Text>
					<a
						href={`https://www.google.com/maps/search/?api=1&query=${nearestLocation.lat},${nearestLocation.lng}`}
						target="_blank"
						rel="noreferrer"
						className={styles.link}
					>
						{nearestLocation.address}
					</a>
				</>
			);
		}

		return (
			<Text size="14px" fw={400}>
				You can drop your Curby bags at your nearest drop-off point.
			</Text>
		);
	}, [nearestLocation, loading]);

	return (
		<WarningAlert
			title="Your address is not eligible for kerbside pickup."
			icon={<IconHomeExclamation />}
		>
			{children}
		</WarningAlert>
	);
};
